<template>
  <div id="app">
    <entete/>
    <router-view :key="$route.fullPath"/>
    <pied-de-page/>
  </div>
</template>

<script>
import Entete from '@/components/Entete'
import PiedDePage from '@/components/PiedDePage'

export default {
  name : 'app',
  components : {
    Entete,
    PiedDePage
  }

}
</script>